require('./cardStatementDetails.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
// @utilities
const DateHelper = require('utilities/dateHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { FormattedText, getLanguage, formatText } = require('core/i18n').i18n;
// @ constants
const {
    CARD_CREDIT,
    DATE_FORMAT_MONTH_YEAR,
    DATE_FORMAT_WITH_SLASHES
} = require('constants/index');

// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { LoadingSection } = require('commonsComponents/loadingSection');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')

class CardStatementDetails extends React.Component {
    render() {
        const { immStatements, statementId, immStatementDetails, cardType } = this.props;

        let content;

        if (immStatements) {
            const immStatement = immStatements.get('byId').get(statementId);
            const cardDetails = {
                settlementDate: DateHelper.buildFormattedDate(immStatement.get('date'), DATE_FORMAT_MONTH_YEAR),
                chargeAccount: immStatementDetails.get('chargeAccount'),
                paymentType: immStatement.get('paymentMethod')
            };
            const plainAmountObject = getPlainAmountObject(immStatement.get('amount'));

            let dateItems;
            if (__CONTACT_CENTER__) {
                const isCredit = cardType === CARD_CREDIT;
                const notApplicableStr = formatText('commons-NA');
                const cutOffDate = isCredit ? DateHelper.formatDate(immStatementDetails.get('date'), DATE_FORMAT_WITH_SLASHES) : notApplicableStr;
                const chargeDate = isCredit ? DateHelper.formatDate(immStatementDetails.get('fecvalor'), DATE_FORMAT_WITH_SLASHES) : notApplicableStr;

                dateItems = [
                    <OKInformativeListItem
                        key="cutOffDate"
                        title="cardStatement-cutOffDate"
                        bodyText={cutOffDate}
                    />,
                    <OKInformativeListItem
                        key="chargeDate"
                        title="cardStatement-chargeDate"
                        bodyText={chargeDate}
                    />
                ];
            }

            content = (
                <OKSectionBox className="card-statementdetails">
                    <div className="card-statementdetails__amount">
                        <FormattedText
                            value="cardStatement-chargeAmount"
                            className="card-statementdetails__amount-title"
                        />
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            className="card-statementdetails__amount-number"
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                        />
                    </div>
                    <OKInformativeList>
                        <OKInformativeListItem title="cardStatement-settlementDate" bodyText={cardDetails.settlementDate} />
                        <OKInformativeListItem title="cardStatement-chargeAccount" bodyText={cardDetails.chargeAccount} />
                        <OKInformativeListItem title="cardStatement-paymentType" bodyText={cardDetails.paymentType} />
                        <ContactCenterRender>
                            {dateItems}
                        </ContactCenterRender>
                    </OKInformativeList>
                </OKSectionBox>
            )
        } else {
            content = <LoadingSection />;
        }

        return content;
    }
}

CardStatementDetails.propTypes = {
    cardType: PropTypes.string,
    immStatements: PropTypes.object,
    statementId: PropTypes.string.isRequired,
    immStatementDetails: PropTypes.object.isRequired
};

module.exports = CardStatementDetails;
